import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "thematic_matters" }
const _hoisted_2 = { class: "container rel" }
const _hoisted_3 = { class: "matters" }

import { useRouter } from 'vue-router'

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()
const toPath = (path:string) => {
    router.push(path)
}

const toYyyz = ()=> {
  router.push({
    path: '/do-things-online',
    query: {
      listName: 'yyyz',
    },
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "news" }, [
        _createElementVNode("span", null, "新闻热点"),
        _createElementVNode("img", { src: "images/laba.gif" }),
        _createElementVNode("p", null, "自贸试验区开封片区举行党的二十大精神专题宣讲会")
      ], -1)),
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (toPath('/one-thing')))
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("img", { src: "images/matters1.png" }, null, -1),
          _createElementVNode("h1", null, "高效办成一件事", -1),
          _createElementVNode("p", null, "集成化办理，大幅减少办事环节", -1)
        ]))]),
        _createElementVNode("li", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (toPath('/second-batch')))
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("img", { src: "images/matters2.png" }, null, -1),
          _createElementVNode("h1", null, "智能速办", -1),
          _createElementVNode("p", null, "高效能、智能化、不见面政务服务办事体验", -1)
        ]))]),
        _createElementVNode("li", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (toYyyz()))
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("img", { src: "images/matters3.png" }, null, -1),
          _createElementVNode("h1", null, "一业一证专区", -1),
          _createElementVNode("p", null, "一个行业一种证照", -1)
        ]))])
      ])
    ])
  ]))
}
}

})